import React from "react";
import { ContactForm } from "../../organisms/form/ContactForm";
import styled from "styled-components";
import { ReactComponent as TelegramIcon } from "../../../assets/telegram.svg";
import { ReactComponent as WhatsappIcon } from "../../../assets/whatsapp.svg";
import { ReactComponent as PhoneIcon } from "../../../assets/phone.svg";
import { ReactComponent as YoutubeIcon } from "../../../assets/youtube.svg";
import { ReactComponent as FacebookSvgIcon } from "../../../assets/facebook.svg";
import { ReactComponent as EmailIcon } from "../../../assets/email.svg";
import { ReactComponent as AddressIcon } from "../../../assets/address.svg";
import { useLanguage } from '../../../contexts/LanguageContext';

export const ContactPage = () => {
  const { t } = useLanguage();
  return (
    <Container>
      <HeaderContainer>
        <TitleWrapper>{t('contact.page.contactOurTeam')}</TitleWrapper>
      </HeaderContainer>
      <FormContainer>
        <LeftSection>
          <ContactForm />
        </LeftSection>
        <RightSection>
          <SidebarBlock>
            <SidebarTitle>{t('contact.page.contactUs')}</SidebarTitle>
            {/* <SidebarDesc>{t('contact.page.contactHours')}</SidebarDesc> */}
            <SidebarList>
              <SidebarItem>
                <SidebarIcon>
                  <PhoneIcon />
                </SidebarIcon>
                <SidebarLink href="tel:+85585281712">
                  +855 85 281 712
                </SidebarLink>
              </SidebarItem>
              <SidebarItem>
                <SidebarIcon>
                  <TelegramIcon />
                </SidebarIcon>
                <SidebarLink href="https://t.me/+85585281712" target="_blank" rel="noopener noreferrer">
                  {t('contact.page.telegram')}
                </SidebarLink>
              </SidebarItem>
              <SidebarItem>
                <SidebarIcon>
                  <WhatsappIcon />
                </SidebarIcon>
                <SidebarLink href="https://wa.me/85585281712" target="_blank" rel="noopener noreferrer">
                  {t('contact.page.whatsapp')}
                </SidebarLink>
              </SidebarItem>
              <SidebarItem>
                <SidebarIcon>
                  <EmailIcon />
                </SidebarIcon>
                <SidebarLink href="mailto:Livingppbox@gmail.com" target="_blank" rel="noopener noreferrer">
                  Livingppbox@gmail.com
                </SidebarLink>
              </SidebarItem>
              <SidebarItem>
                <SidebarIcon>
                  <AddressIcon />
                </SidebarIcon>
                <AddressText>
                  Street.402, Tom Nup Teuk, Boeng Keng Kong, Phnom Penh
                </AddressText>
              </SidebarItem>
            </SidebarList>
          </SidebarBlock>
          <SidebarBlock>
            <SidebarTitle>{t('contact.page.followUs')}</SidebarTitle>
            <SidebarDesc>{t('contact.page.stayUpdated')}</SidebarDesc>
            <SidebarList>
              <SidebarItem>
                <SidebarIcon>
                  <FacebookSvgIcon />
                </SidebarIcon>
                <SidebarLink href="https://www.facebook.com/livingpp" target="_blank" rel="noopener noreferrer">
                  Living PP
                </SidebarLink>
              </SidebarItem>
              <SidebarItem>
                <SidebarIcon>
                  <YoutubeIcon />
                </SidebarIcon>
                <SidebarLink href="https://www.youtube.com/@LIVINGPP" target="_blank" rel="noopener noreferrer">
                  LIVINGPP
                </SidebarLink>
              </SidebarItem>
            </SidebarList>
          </SidebarBlock>
        </RightSection>
      </FormContainer>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 12px 40px;
  margin: 20px auto 0;
  width: 100%;
  
  @media (min-width: 400px) {
    padding: 0 16px 50px;
    margin: 30px auto 0;
  }
  
  @media (min-width: 768px) {
    padding: 0 24px 57px;
    margin: 40px auto 0;
  }
  
  @media (min-width: 900px) {
    padding: 0 16px 57px;
    margin: 50px auto 0;
  }
`;

const TitleWrapper = styled.div`
  font-size: 24px;
  padding: 0 0 8px 0;
  display: flex;
  line-height: 1.2;
  font-weight: 700;
  margin-bottom: 24px;
  justify-content: center;
  text-align: center;
  font-family: "Hiragino Sans", sans-serif;
  
  @media (min-width: 600px) {
    font-size: 32px;
    margin-bottom: 32px;
  }
  
  @media (min-width: 900px) {
    font-size: 40px;
    margin-bottom: 38px;
  }
`;

const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: center;
  gap: 24px;
  
  @media (min-width: 900px) {
    flex-direction: row;
    gap: 64px;
  }
`;

const LeftSection = styled.div`
  flex: 1 1 0;
  min-width: 0;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  
  @media (min-width: 900px) {
    min-width: 520px;
    max-width: 750px;
  }
`;

const RightSection = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
  
  @media (min-width: 900px) {
    width: 380px;
    margin-left: 0;
    gap: 10px;
  }
`;

const SidebarBlock = styled.div`
  margin-bottom: 16px;
  
  @media (min-width: 900px) {
    margin-bottom: 10px;
  }
`;

const SidebarTitle = styled.div`
  font-size: 15px;
  font-weight: 600;
  margin-bottom: 12px;
  
  @media (min-width: 768px) {
    font-size: 16px;
    margin-bottom: 10px;
  }
`;

const SidebarDesc = styled.div`
  font-size: 12px;
  color: #888;
  margin-bottom: 12px;
  
  @media (min-width: 768px) {
    font-size: 13px;
  }
`;

const SidebarList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

const SidebarItem = styled.li`
  display: flex;
  align-items: flex-start;
  font-size: 14px;
  margin-bottom: 12px;
  gap: 10px;
  
  @media (min-width: 768px) {
    font-size: 15px;
    margin-bottom: 10px;
  }
`;

const SidebarIcon = styled.span`
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  
  @media (min-width: 768px) {
    font-size: 18px;
    width: 20px;
    height: 20px;
  }
`;

const SidebarLink = styled.a`
  color: #333;
  text-decoration: none;
  font-size: 14px;
  
  @media (min-width: 768px) {
    font-size: 15px;
  }
  
  &:hover {
    color: #007bff;
    text-decoration: underline;
  }
`;

const AddressText = styled.span`
  color: #333;
  font-size: 14px;
  line-height: 1.4;
  
  @media (min-width: 768px) {
    font-size: 15px;
  }
`;
